/**
 * Partner / brand logo.
 *
 * Renders the uploaded logo when there is one, and falls back to a typographic
 * treatment of the name when there is not — which is how the site shipped,
 * before logos could be uploaded at all.
 *
 * The fallback also covers a broken image URL, so a deleted file in Storage
 * degrades to the partner's name rather than a broken-image icon.
 */

import { useState } from "react";

export default function PartnerLogo({ name, logo, className = "" }) {
  const [failed, setFailed] = useState(false);

  if (logo && !failed) {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        {/* Fixed box + object-contain: every partner logo occupies the same
            space and sits centred, whether it is square or a wide wordmark.
            The box is deliberately close to 2:1 rather than long and thin — in a
            wide, short box a square logo can only ever fit by its height and
            ends up looking half the size of its neighbours. */}
        <span className="flex items-center justify-center h-20 w-36">
          <img
            src={logo}
            alt={name}
            loading="lazy"
            onError={() => setFailed(true)}
            className="max-h-full max-w-full object-contain"
          />
        </span>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <span className="text-xl md:text-2xl font-extrabold tracking-tight text-ink/70">{name}</span>
    </div>
  );
}
